namespace GeniuzPOS.ReportMasterData {
    export interface Report_1501Row {
        Id?: string;
        DocDate?: string;
        DocDateEn?: string;
        Year?: string;
        CatCode?: string;
        CatName?: string;
        Qty?: number;
        GrossSales?: number;
        NetSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1501Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1501';
        export const lookupKey = 'ReportMasterData.Report_1501';

        export function getLookup(): Q.Lookup<Report_1501Row> {
            return Q.getLookup<Report_1501Row>('ReportMasterData.Report_1501');
        }
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            DocDateEn = "DocDateEn",
            Year = "Year",
            CatCode = "CatCode",
            CatName = "CatName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            NetSales = "NetSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
